import LocalizedStrings from 'localized-strings';

interface SelectAmountAndCurrencyLocales {
  amountLabel: string;
  amountOverBalance: string;
  chooseBeneficiaryCTA: string;
  invalidAmount: string;
  toAccount: string;
  transferFees: string;
  transferTypeCardDescription: string;
}

const locales = new LocalizedStrings<SelectAmountAndCurrencyLocales>({
  en: {
    amountLabel: 'Your beneficiary receives',
    amountOverBalance: 'Insufficient funds',
    chooseBeneficiaryCTA: 'Choose my beneficiary',
    invalidAmount: 'Invalid amount',
    toAccount: 'Make a transfer',
    transferFees: 'You will pay : {sourceAmount} (including {fees} of fees)',
    transferTypeCardDescription:
      'Estimated reception {estimatedReceptionDate}.',
  },
  fr: {
    amountLabel: 'Votre bénéficiaire reçoit',
    amountOverBalance: 'Fonds insuffisants',
    chooseBeneficiaryCTA: 'Choisir mon bénéficiaire',
    invalidAmount: 'Montant invalide',
    toAccount: 'Effectuez un virement',
    transferFees: 'Vous payez : {sourceAmount} (dont {fees} de frais)',
    transferTypeCardDescription: 'Réception estimée {estimatedReceptionDate}.',
  },
} as const);

export default locales;
